<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body transaction-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row mt-5">
          <h3>Payment QR Code</h3>
        </div>

        <div class="row">
          <div class="col-12 col-xl-5 pl-0 mb-4">
            <div class="card-style">
              <div v-if="isLoading" class="text-center py-5">
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <QrCard
                v-else
                :payload="payload"
                caption="Scan QR code to pay"
                :file-name="fileName"
                share-title="Pay us with AmejPay"
              ></QrCard>
            </div>
          </div>

          <div class="col-12 col-xl-7 pl-0 mb-4">
            <div class="card-style">
              <span>Where to use it</span>
              <ul class="hint-list">
                <li>Print it and put it at the counter, or add it to an invoice.</li>
                <li>Send the image to a customer in chat or by email.</li>
                <li>
                  A customer scans it in the AmejPay app and pays your business account -
                  they never have to type your details.
                </li>
              </ul>

              <div class="qr-facts">
                <div class="qr-fact">
                  <span>Business name</span>
                  <strong>{{ payload.name || "—" }}</strong>
                </div>
                <div class="qr-fact">
                  <span>Account email</span>
                  <strong>{{ payload.email || "—" }}</strong>
                </div>
                <div class="qr-fact">
                  <span>Code type</span>
                  <strong>Merchant payment</strong>
                </div>
              </div>

              <p class="notice" v-if="!hasBusinessName">
                Your business name is taken from your merchant KYC. Complete
                <router-link :to="{ name: 'merchant-kyc' }">KYC</router-link>
                so customers see the business rather than the account holder.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>
  </div>
</template>

<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";
import QrCard from "../QrCard.vue";
import { mapActions, mapState } from "vuex";
import { merchantPayload } from "@/utils/qrpayload";

export default {
  name: "MerchantQrCode",
  components: { MerchantHeader, MerchantFooter, MerchantSideNav, MenuToggle, QrCard },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapState(["profile", "userKyc"]),
    /** Merchant KYC holds the business name; the email is the account's own. */
    kyc: function () {
      const k = this.userKyc;
      return (k && typeof k === "object") ? k : {};
    },
    hasBusinessName: function () { return !!this.kyc.business_name; },
    payload: function () { return merchantPayload(this.profile, this.kyc); },
    fileName: function () {
      const name = String(this.payload.name || "amejpay").toLowerCase().replace(/\s+/g, "-");
      return "amejpay-merchant-qr-" + name;
    },
  },
  created() {
    this.isLoading = true;
    const vm = this;
    return Promise.all([this.listProfile(), this.listUserKyc()])
      .then(function () { vm.isLoading = false; })
      .catch(function () { vm.isLoading = false; });
  },
  methods: {
    ...mapActions(["listProfile", "listUserKyc"]),
  },
};
</script>

<style lang="scss" scoped>
.hint-list { padding-left: 18px; margin: 10px 0 16px; }
.hint-list li { font-size: 13px; color: #6c757d; margin-bottom: 8px; }
.qr-facts { border-top: 1px solid #eef1f4; padding-top: 12px; }
.qr-fact {
  display: flex; justify-content: space-between; gap: 16px;
  padding: 7px 0; border-bottom: 1px solid #f6f7f9; font-size: 13px;
}
.qr-fact:last-child { border-bottom: none; }
.qr-fact span { color: #6c757d; }
.qr-fact strong { color: #2c3e50; text-align: right; word-break: break-word; }
.notice {
  background: #fdf3e0; color: #8a5a00; border-radius: 6px;
  padding: 10px 12px; font-size: 13px; margin: 14px 0 0;
}
</style>
